$(document).ready(() => {
    const $itemsBlock = $('.transfers__items');
    let page = 1;

    const $moreTransfers = $('.more_transfers').off().on('click', event => {
        event.preventDefault();
        page += 1;
        getTransfers();
    });

    const $search = $('.transfers_search').on(
        'keyup',
        _.debounce(
            function () {
                page = 1;
                getTransfers();
            },
            1000
        )
    );

    getTransfers();

    function getTransfers() {
        const data = {
            page: page,
            per_page: TRANSFERS_PER_PAGE,
        };
        if ($search.val()) {
            data.search = $search.val();
        }
        if (TEAM_ID) {
            data.team_id = TEAM_ID;
        }

        if (page === 1) {
            $moreTransfers.show();
            $itemsBlock.empty();
        }
        $('.no_transfers').hide();
        TRNMNT_helpers.disableButtons();

        $.ajax({
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            type: 'get',
            url: TRANSFERS_URL + '?' + jQuery.param(data),
            processData: false,
            success: response => {
                // const $lastBlock = $('.transfers__items .transfer-card').last();
                // if ($lastBlock.length) {
                //     $([document.documentElement, document.body]).animate({
                //         scrollTop: $lastBlock.offset().top
                //     }, 0);
                // }

                for (let transfer of response.data) {
                    const $template = $('#templates').find('.transfer-card').clone();
                    const date = new Date(transfer.date);

                    const icon3x3 = '<img src="/images/3x3.svg" alt="3x3" class="w-100">';
                    const icon6x6 = '<img src="/images/6x6.svg" alt="6x6" class="w-100">';
                    let icon = icon3x3 + '<br>' + icon6x6;
                    if (transfer.mode === '3x3') {
                        icon = icon3x3;
                    } else if (transfer.mode === '6x6') {
                        icon = icon6x6;
                    }

                    $template.find('.transfer-card__num').html(icon);
                    $template.find('.transfer-card__img').attr('href', transfer.user.link);
                    $template.find('.transfer-card__img-wrap img')
                        .attr('src', transfer.user.avatar)
                        .attr('alt', transfer.user.tag);
                    $template.find('.transfer-card__img-wrap .fis')
                        .addClass('fi-' + transfer.user.country_id)
                    $template.find('.transfer-card__player1 .transfer-card__player-img .fa-' + transfer.user.platform)
                        .show();
                    $template.find('.transfer-card__player1 .transfer-card__player-title a')
                        .attr('href', transfer.user.link)
                        .text(transfer.user.tag);
                    $template.find('.transfer-card__player1 .transfer-card__player-desc').text(transfer.user.name);

                    $template.find('.transfer-card__arrow img').attr('src', transfer.icon);

                    $template.find('.transfer-card__team a').attr('href', transfer.team.link);
                    $template.find('.transfer-card__team img')
                        .attr('src', transfer.team.avatar)
                        .attr('alt', transfer.team.title);
                    $template.find('.transfer-card__player2 .transfer-card__player-img .fa-' + transfer.team.platform)
                        .show();
                    $template.find('.transfer-card__player2 .transfer-card__player-title a')
                        .attr('href', transfer.team.link)
                        .text(transfer.team.title);
                    $template.find('.transfer-card__player2 .transfer-card__player-desc')
                        .text(date.getFullDate());

                    $itemsBlock.append($template);
                }

                if ($itemsBlock.children().length === response.recordsTotal) {
                    $moreTransfers.hide();
                }
                if (page === 1 && response.recordsTotal === 0) {
                    $('.no_transfers').show();
                }
                TRNMNT_helpers.enableButtons();
            },
            error: TRNMNT_helpers.onErrorAjax,
            context: TRNMNT_helpers
        });
    }
});
